<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        ข้อมูลสัดส่วนการคิดค่าบริการโทรศัพท์เคลื่อนที่
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i>ข้อมูลสัดส่วนการคิดค่าบริการโทรศัพท์เคลื่อนที่
          </a>
        </li>
        <li class="active">ข้อมูลสัดส่วนการคิดค่าบริการโทรศัพท์เคลื่อนที่</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12" style="height:660px;">
            <div class="box box-primary">
              <div class="box-header with-border">
                <h3 class="box-title">แก้ไขสัดส่วนการคิดค่าบริการโทรศัพท์เคลื่อนที่</h3>
              </div>
              <div class="box-body">
                <div class="wrapper_edit_typegroup">
                  <div class="row">
                    <div class="col-sm-6">
                      <el-form size="small">
                        <el-form-item label="โปรนาที(%)">
                          <el-input
                            type="number"
                            min="0"
                            max="100"
                            placeholder="กรุณาระบุสัดส่วน"
                            v-model="proportion_minute"
                            width="200px"
                            @keypress.native="isNumberKey"
                            @change="setPercentage('minute')"
                          ></el-input>
                          <span>%</span>
                        </el-form-item>
                      </el-form>
                    </div>
                    <div class="col-sm-6">
                      <el-form size="small">
                        <el-form-item label="โปรวินาที(%)">
                          <el-input
                            type="number"
                            min="0"
                            max="100"
                            placeholder="กรุณาระบุสัดส่วน"
                            v-model="proportion_second"
                            width="200px"
                            @keypress.native="isNumberKey"
                            @change="setPercentage('second')"
                          ></el-input>
                          <span>%</span>
                        </el-form-item>
                      </el-form>
                    </div>
                  </div>
                  <div class="box-footer">
                    <el-button type="primary" @click="updateMobile({proportion_minute,proportion_second,id})">ยืนยัน</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      proportion_minute:null,
      proportion_second:null,
      id:null
    };
  },
  computed: {
    ...mapState({

    })
  },
  mounted() {
    let params = this.$route.params;
    this.proportion_minute = params.proportion_minute;
    this.proportion_second = params.proportion_second;
    this.id = params.id;
  },
  methods: {
    ...mapActions({
      updateMobile:"ManageService/updateMobile"
    }),
    setPercentage(type){
      if(type == 'minute'){
        this.proportion_second = 100 - this.proportion_minute
      }else{
        this.proportion_minute = 100 - this.proportion_second
      }
    }
  }
};
</script>
